/** Defaults aligned with functions/notifyPreferences.js */

export function defaultNotifyPrefs() {
  return {
    channels: { inApp: true, push: true, email: true },
    categories: {
      todoCreated: true,
      todoAssigned: true,
      todoReminders: true,
      todoDeadlines: true,
      calendarInvites: true,
      calendarCreated: true,
      calendarReminders: true,
      chatMessages: true,
      chatUnanswered: true,
      profileScore: true,
    },
  };
}

export function defaultAppSettings() {
  return {
    denseUi: false,
    reduceMotion: false,
  };
}

export function mergeNotifyPrefsFromUser(userData) {
  const d = defaultNotifyPrefs();
  const raw = userData?.notifyPrefs;
  if (!raw || typeof raw !== 'object') return d;
  return {
    channels: { ...d.channels, ...(raw.channels || {}) },
    categories: { ...d.categories, ...(raw.categories || {}) },
  };
}

export function mergeAppSettingsFromUser(userData) {
  const d = defaultAppSettings();
  const raw = userData?.appSettings;
  if (!raw || typeof raw !== 'object') return d;
  return {
    denseUi: raw.denseUi === true,
    reduceMotion: raw.reduceMotion === true,
  };
}
